<template>
  <div>
    <b-form-group label="Tipo de Pessoa:">
      <b-form-radio
        v-model="tipoPessoa"
        name="tipo"
        value="cpf"
        >Pessoa Física</b-form-radio
      >
      <b-form-radio
        v-model="tipoPessoa"
        name="tipo"
        value="cnpj"
        >Pessoa Jurídica</b-form-radio
      >
    </b-form-group>

    <b-row>
      <b-col cols="10">
        <b-form-group v-if="tipoPessoa === 'cpf'" label="Nome:">
          <b-form-input
            v-model="perfil.nome"
            placeholder="Nome"
          ></b-form-input>
          <b-form-invalid-feedback
            >Nome é um campo obrigatório.</b-form-invalid-feedback
          >
        </b-form-group>
        <b-form-group v-else label="Razão social:">
          <b-form-input
            v-model="perfil.razao_social"
            placeholder="Nome"
          ></b-form-input>
          <b-form-invalid-feedback
            >Nome é um campo obrigatório.</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Status:">
          <b-form-checkbox v-model="perfil.status" value="1" unchecked-value="0">
            Ativo
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-group v-if="tipoPessoa === 'cpf'" label="CPF:">
      <b-form-input
        v-model="perfil.documento"
        placeholder="CPF"
      ></b-form-input>
      <b-form-invalid-feedback
        >CPF é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>
    
    <b-row v-else>
      <b-col cols="6">
        <b-form-group label="CNPJ:">
          <b-form-input
            v-model="perfil.documento"
            placeholder="CPNJ"
          ></b-form-input>
          <b-form-invalid-feedback
            >CPNJ é um campo obrigatório.</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Nome Fantasia:">
          <b-form-input
            v-model="perfil.nome_fantasia"
            placeholder="Nome Fantasi"
          ></b-form-input>
          <b-form-invalid-feedback
            >Nome é um campo obrigatório.</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="tipoPessoa === 'cnpj'">
      <b-col cols="6">
        <b-form-group label="Categoria da instituição:">
          <categorias-instituicoes v-model="perfil.categoria_instituicao_id" />
          <b-form-invalid-feedback
            >Categoria da instituição é um campo obrigatório.</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Tipo da instituição:">
          <tipo-instituicoes v-model="perfil.tipo_instituicao_id" />
          <b-form-invalid-feedback
            >Tipo de instituição é um campo obrigatório.</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="4">
        <b-form-group label="Cep:">
          <b-form-input
            v-model="perfil.cep"
            placeholder="Cep"
            @keypress="onlyNumbers($event)"
            maxlength="10"
            size="md"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="3">
        <b-form-group label="Estado:">
          <select-estado v-model="uf" ref="selecEstado" size="md" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Cidade:">
          <select-municipio
            v-model="perfil.cidade_id"
            :uf="uf"
            ref="selecCidade"
            size="md"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="6">
        <b-form-group label="Áreas da oportunidade:">
          <select-area v-model="perfil.areas" :multiple="true" />
          <b-form-invalid-feedback>
            <span>Áreas da Oportunidade é um campo obrigatório.</span>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Categorias da oportunidade:">
          <categorias v-model="perfil.categoria_id" />
          <b-form-invalid-feedback
            >Categoria da instituição é um campo obrigatório.</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { cnpj as cnpjValidator } from "cpf-cnpj-validator";
import { mapState } from "vuex";

import CategoriasInstituicoes from "./CategoriasInstituicoes.vue";
import TipoInstituicoes from "./TipoInstituicoes.vue";
import Categorias from "./Categorias.vue";
import SelectArea from "@/modules/areas/Components/SelectArea.vue";

export default {
  mixins: [validationMixin],
  components: {
    CategoriasInstituicoes,
    TipoInstituicoes,
    SelectArea,
    Categorias
  },
  data: () => ({
    tipoPessoa: 'cpf',
    uf: "",
  }),
  validations: {
    perfil: {
      nome: {
        required,
        minLength: minLength(3),
      },
    },
  },
  computed: {
    ...mapState("perfis", ["perfil"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.perfil[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.perfil.$touch();
      return !this.$v.perfil.$anyError;
    },
    onlyNumbers(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validateProfileType() {
      const isCNPJ = this.perfil?.documento;
      if (isCNPJ) {
        this.tipoPessoa = cnpjValidator.isValid(isCNPJ) ? "cnpj" : "cpf";
      }
    }
  },
  watch: {
    "perfil.cidade_id": {
      deep: true,
      handler: function (value) {
        if (this.$refs["selecCidade"]) {
          let cidade = this.$refs["selecCidade"].municipio;
          if (cidade) {
            this.$refs["selecEstado"].setBySigla(cidade.estado_sigla);
          }
        }
      },
    },
    "perfil.cep": async function (value) {
      let cep = value ? value : "";
      cep = cep.replace(/\D/g, "");
      let url = `https://viacep.com.br/ws/${cep}/json/`;
      if (cep) {
        this.show_overlay = true;
        var validaCep = /^[0-9]{8}$/;
        if (validaCep.test(cep)) {
          await fetch(url)
            .then((response) => response.json())
            .then((response) => {
              this.perfil.estado_sigla = response.uf;
              this.perfil.cidade_id = response.ibge;
            })
            .catch((error) => console.log(error));
        }
      }
      this.show_overlay = false;
    },
  },
  created() {
    if (this.perfil?.cidade) {
      this.uf = this.perfil.cidade.estado_sigla;
    }
  },
};
</script>
